module.exports = __webpack_public_path__ + "img/freespin_multiplier.3e51e738.png";